import React from "react";
import "./SemiPlannedPublishingPage.css";
import HeadlineArea from "./HeadlineArea";
import ProcessStepSelector from "../Shared/ProcessStepSelector/ProcessStepSelector";
import AcornSemiPlannedPublishing from "./StepsComponents/Step1/AcornSemiPlannedPublishing";
import SemiPlannedProcess from "./StepsComponents/Step2/SemiPlannedPublishingProcess";
import SemiPlannedMarketing from "./StepsComponents/Step3/SemiPlannedMarketing";
import SemiPlannedCosts from "./StepsComponents/Step4/SemiPlannedCosts";
import Footer from "../../Footer";

const SemiPlannedPublishingPage = () => {
  const stepsData = [
    {
      label: "에이콘 반기획 출판",
      Component: AcornSemiPlannedPublishing,
    },
    {
      label: "출판 과정",
      Component: SemiPlannedProcess,
    },
    {
      label: "출판 마케팅",
      Component: SemiPlannedMarketing,
    },
    {
      label: "출판 비용",
      Component: SemiPlannedCosts,
    },
  ];
  return (
    <>
      <HeadlineArea />
      <ProcessStepSelector stepsData={stepsData} />
      <Footer />
    </>
  );
};

export default SemiPlannedPublishingPage;
